import { Tooltip } from 'ant-design-vue';
import { h } from 'vue';
import type { ComponentType } from '@mts/components/Form/src/types';
import type { Fn } from '@mts-fe/types';
import type { defineComponent } from 'vue';
import { componentMap } from '@mts/components/Form/src/componentMap';

export interface ComponentProps {
  component: ComponentType;
  hasRule: boolean;
  ruleMessage: string;
  getPopupContainer?: Fn;
}

export default (
  { component, hasRule = true, ruleMessage, getPopupContainer }: ComponentProps,
  { attrs },
) => {
  const Comp = componentMap.get(component) as typeof defineComponent;
  return h(Comp, attrs);

  const DefaultComp = h(Comp, attrs);
  if (!hasRule) {
    return DefaultComp;
  }

  return h(
    Tooltip,
    {
      overlayClassName: 'edit-cell-rule-popover',
      open: !!ruleMessage,
      trigger: 'focus',
      color: '#ed6f6f',
      ...(getPopupContainer ? { getPopupContainer } : {}),
    },
    {
      default: () => DefaultComp,
      title: () => ruleMessage,
    },
  );
};
